import React from "react";
import Flexbox from "flexbox-react";
import { inject, observer, Provider } from "mobx-react";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import LayoutHeader from "../components/layout/LayoutHeader";
import ToastStore from "../stores/ToastStore";
import CurrentUserStore from "../stores/CurrentUserStore";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import PageHeading from "../components/goals/PageHeading.js";
import TabSelector from "../components/onboarding_settings/TabSelector.js";
import axios from "axios";
import Cookies from "js-cookie";
import StepsManager from "../components/onboarding_settings/StepsManager.js";
import QuestionManager from "../components/onboarding_settings/QuestionManager.js";
import EmployeePipelineManager from "../components/onboarding_settings/EmployeePipelineManager.js";
import "../components/onboarding_settings/OnboardingSettingsView.css";


@observer
export default class OnboardingSettingsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null,
            activeTab: 'steps',
            onboardingSettings: [],
        };
    }

    componentDidMount() {
        //  this.setState({ isLoading: true });
        axios.get(`${Cookies.get("apiEnv")}/onboarding/settings`)
            .then(response => {
                this.setState({ onboardingSettings: response.data });
            })
    }



    render() {
        const stores = {
            ToastStore,
            CurrentUserStore,
        };
        const { isLoading, activeTab } = this.state;
        return (
            <Provider {...stores}>
                <ThemeWrapper>
                    <ErrorBoundary>
                        <Flexbox flexGrow={1}
                            width="100hw"
                            alignContent="stretch"
                            flexDirection="column"
                            className="push-20-l push-20-r">
                            {!isLoading ? (
                                <Flexbox flexDirection="column" padding="20px" marginLeft="10px">

                                    <PageHeading text="Check-ins Settings" description="Configure the check-ins settings for your organization." />
                                    <TabSelector activeTab={activeTab} onTabChange={tab => this.setState({ activeTab: tab })} />

                                    {activeTab === 'steps' && (
                                        <StepsManager />
                                    )}                                   
                                    {activeTab === 'employeePipelines' && (
                                        <EmployeePipelineManager />
                                    )}
                                </Flexbox>
                            ) : (
                                <div>Loading...</div>
                            )}

                        </Flexbox>
                    </ErrorBoundary>
                </ThemeWrapper>
            </Provider>
        );

    }
}